import { Controller } from "@hotwired/stimulus";
import getCsrfToken from "../utils/csrf";
import { initializeRadioButtons } from "../components/square-radio-button";
import { useDispatch } from "stimulus-use";
import moment from "moment/moment";
import { t } from "../i18n/t";
import $ from "jquery";

export default class extends Controller {
  static targets = ["modal", "dateHint", "channelHint", "dateRange", "from", "to", "price", "offer",
                            "listingList", "selectedList", "addNewBookingBtn", "loadMoreBtn"];
  static listingsFetchTimer;
  static validationTimer;
  static nextStepTimer;

  connect() {
    useDispatch(this);
    initializeRadioButtons();
    this.initializeOfferTypeSection();
    this.initializeListingSection();
    this.initializeControls();
    this.startValidationMonitor();
  }

  showElements() {
      if (this.hasOfferTarget && this.hasListingListTarget) {
          [this.offerTarget, this.listingListTarget].forEach(el => {
              el.classList.remove("is-hidden");
              el.parentElement.classList.remove("is-hidden");
          });
      }
  }

  moveSelectedToTop() {
      if (this.hasLoadMoreBtnTarget) {
          this.loadMoreBtnTarget.classList.remove('is-hidden');
      }
      if (this.hasSelectedListTarget) {
          const parent = this.selectedListTarget.parentElement;
          if (parent?.firstChild) {
              parent.insertBefore(this.selectedListTarget, parent.firstChild);
          }
      }
  }

  showAddBookingBtn() {
      if (this.hasAddNewBookingBtnTarget) {
          this.addNewBookingBtnTarget.classList.remove('is-hidden');
      }
  }

  hideAddBookingBtn() {
      if (this.hasAddNewBookingBtnTarget) {
          this.addNewBookingBtnTarget.classList.add('is-hidden');
      }
  }

  initializeOfferTypeSection() {
    if (!this.differentTypesAllowed) {
      return;
    }

    const offerTypeInput = document.getElementById("offer_type");
    const offerTypeOptions = document.querySelectorAll("label.offer_type_option");

    offerTypeOptions.forEach((option) => {
      option.addEventListener("click", () => {
        const type = option.querySelector('input[name="offer[type]"]').value;

        offerTypeInput.value = type;
        this.toggleTenantPaidField(type);
        this.toggleDisableEmailToTenant(type);
        this.toggleExpiresInField(type);
        this.updateHeader(type);
        this.updateDescription(type);
        this.updateSubmitButton(type);

        offerTypeOptions.forEach((option) => option.classList.remove("selected"));
        option.classList.add("selected");
      });
    });
  }

  initializeListingSection() {
    const listingsSearchInput = document.getElementById("offer_listing");
    const channelSelection = document.getElementById("offer_channel");
    this.listingsFetchTimer = setInterval(() => {
      const term = listingsSearchInput.getAttribute("data-term");
      const newTerm = listingsSearchInput.value;

      const channelId = listingsSearchInput.getAttribute("data-channelid");
      let newChannelId = "0";
      if (channelSelection) {
        newChannelId = channelSelection.value;
      }

      if (term !== newTerm || channelId !== newChannelId) {
        let editTrue = document.getElementById("offer_edit_form")?.value === "true";
        let addBookingsSection = document.querySelector(".add_bookings_section")
        if (channelSelection.value !== "" && !editTrue && addBookingsSection) {
            addBookingsSection.classList.add('collapsed');
            addBookingsSection.nextElementSibling?.classList.add('show');
        }

        const searchUrl = listingsSearchInput.getAttribute("data-url");
        const listingIdContainer = document.getElementById("offer_listing_id");
        let listingId = listingIdContainer.value;

        listingsSearchInput.setAttribute("data-term", newTerm);
        listingsSearchInput.setAttribute("data-channelid", newChannelId);

      if (this.hasChannelHintTarget) {
        if (newChannelId === "") {
          $(this.channelHintTarget).show();
        } else {
          $(this.channelHintTarget).hide();
        }
      }

        fetch(`${searchUrl}?term=${newTerm}&listing_id=${listingId}&channel_id=${newChannelId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": getCsrfToken(),
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.renderListingsList(data);
          });
      }
    }, 700);
  }

  initializeControls() {
      setTimeout(() => {
          let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();
          const sendBtn = bulk ? document.querySelector("#offer_bulk_form .send-btn") : document.querySelector("#offer_form .send-btn");
          if (sendBtn) {
            sendBtn.addEventListener("click", () => {
                this.sendOffer(sendBtn);
            });
          }
      }, 700);
    $(this.modalTarget).on("hidden.bs.modal", () => {
      clearTimeout(this.listingsFetchTimer);
      clearTimeout(this.validationTimer);
      clearTimeout(this.nextStepTimer);
      this.modalTarget.remove();
    });

    if (document.querySelectorAll("#selected_listings .bulk-selected").length > 0) {
      document.getElementById("offer_listing_id")?.setAttribute('data-validate', 'false');
    }
  }

  startValidationMonitor() {
    const that = this;
    this.validationTimer = setInterval(() => {
      document
        .querySelectorAll(
          "#offer_type_section, #add_bookings_section, #listing_section, #price_section, #rent_section, #terms_section, #message_section, #concept_section, #channel_section, #unit_section, #attachments_section"
        )
        .forEach((section) => {
          that.updateSectionIndicator(section);
        });
    }, 500);
  }

  renderListingsList({ listings, meta: { current_page, per_page, total_entries } }) {
    if (this.hasListingListTarget && Number(current_page) === 1) {
        this.listingListTarget.innerHTML = "";
    }
    if (this.hasLoadMoreBtnTarget) {
        this.loadMoreBtnTarget.innerHTML = "";
    }

    listings.forEach((listing) => {
      const listingLine = this.buildListingLine(listing);
      if (this.hasListingListTarget) {
          this.listingListTarget.append(listingLine);
      }
    });

    const remainingCount = total_entries - current_page * per_page;
    if (remainingCount > 0) {
      let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();
      const loadMoreButton = document.createElement("button");
      loadMoreButton.setAttribute("data-action", "offers#loadMoreListings");
      loadMoreButton.setAttribute("data-next-page", current_page + 1);
      loadMoreButton.className =
          `bg-light-green inline-block w-full rounded py-3 text-center text-sm font-extrabold text-white ${bulk ? '' : 'mt-[16px]' }`;
      loadMoreButton.innerHTML = `${this.loadMoreText} (+${remainingCount})`;

      if (this.hasLoadMoreBtnTarget) {
          this.loadMoreBtnTarget.append(loadMoreButton);
      }
    }
    this.updateOfferListingId();

    let editTrue = document.getElementById("offer_edit_form")?.value === "true";
    if (editTrue) {
        let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();
        const sendBtn = bulk ? document.querySelector("#offer_bulk_form .send-btn") : document.querySelector("#offer_form .send-btn");
        if (sendBtn) {
            sendBtn.disabled = true;
        }

          const form = document.getElementById("offer_bulk_form");
          let bookingRemoveBtn = document.querySelectorAll('.icon-trash-can');
          bookingRemoveBtn.forEach((button) => {
              button.addEventListener("click", (event) => {
                  event.stopPropagation();
                  let selectedListing = button.parentElement.parentElement
                  selectedListing.remove();
                  this.reindexBulkBookings();
                  this.recalculateBulkTotal();
                  this.onPriceOptionsChanged();
                  let selectedListingsPresent = document.getElementById("selected_listings").hasChildNodes();
                  if (selectedListingsPresent) {
                      this.showAddBookingBtn()
                  } else {
                      this.showElements();
                      this.moveSelectedToTop();
                      this.hideAddBookingBtn();
                  }
                  if (document.querySelectorAll("#selected_listings .bulk-selected").length === 0) {
                      if (this.hasFromTarget) this.fromTarget.value = "";
                      if (this.hasToTarget) this.toTarget.value = "";
                  }
              });
          })

          form.querySelector('.total-price__section a')?.classList.add("d-none");

          let from_date = document.querySelector('input[name="offer[from]"]')
          let to_date = document.querySelector('input[name="offer[to]"]')
          setTimeout(() => {
              from_date.setAttribute('data-validate', 'true');
              to_date.setAttribute('data-validate', 'true');
          }, 300);
      }
  }

  loadMoreListings(event) {
    event.preventDefault();
    const nextPage = event.currentTarget.getAttribute("data-next-page");

    const listingsSearchInput = document.getElementById("offer_listing");
    const searchUrl = listingsSearchInput.getAttribute("data-url");

    const term = listingsSearchInput.getAttribute("data-term");
    const channelId = listingsSearchInput.getAttribute("data-channelid");

    const listingIdContainer = document.getElementById("offer_listing_id");
    let listingId = listingIdContainer.value;

    fetch(`${searchUrl}?term=${term}&listing_id=${listingId}&channel_id=${channelId}&page=${nextPage}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCsrfToken(),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        this.renderListingsList(data);
      });
  }

  buildListingLine(listing) {
    const listingLine = document.createElement("div");
    listingLine.classList.add("listing-line", "mb-4", "bg-white");
    listingLine.setAttribute("data-listing-id", listing.id);
    if (listing.cancellation_policy) {
      listingLine.setAttribute("data-listing-cancellation-policy", listing.cancellation_policy);
    }

    const listingInfo = document.createElement("div");
    listingInfo.classList.add("listing-info");

    const listingTitle = document.createElement("span");
    listingTitle.classList.add("listing-title");
    listingTitle.innerHTML = listing.title;
    listingInfo.append(listingTitle);

    const listingDescription = document.createElement("span");
    listingDescription.classList.add("listing-description");
    listingDescription.innerHTML = listing.description;
    listingInfo.append(listingDescription);

    const listingImage = document.createElement("div");
    listingImage.classList.add("listing-image");
    listingImage.style["display"] = "inline-block";
    if (listing.image_url) {
      listingImage.style["background"] = "url(" + listing.image_url + ")";
      listingImage.style["background-size"] = "contain";
    }

    listingLine.append(listingImage);
    listingLine.append(listingInfo);

    listingLine.addEventListener("click", () => {
      if (listingLine.classList.contains("selected")) return;

      this.selectListing(listingLine);
    });

    return listingLine;
  }

    addNewBooking(event) {
      this.showElements();
      this.moveSelectedToTop();
      event.target.classList.add('is-hidden');
    }

    reindexBulkBookings() {
        const selected = document.querySelectorAll('#selected_listings .selected_listings_date')

        selected.forEach((bookingEl, newIndex) => {
            const rewriteValue = (value) => {
                if (!value) return value

                return value
                    .replace(/\[bookings_attributes\]\[\d+\]/g, `[bookings_attributes][${newIndex}]`)
                    .replace(/_(\d+)(?=_|$)/g, `_${newIndex}`)
                    .replace(/(booking|daterange|selectedlistingsdate|selectedlistingsprice|offerfrom|offerto|offerdates|offerprice|from|to)(\d+)(?=[a-z_]|$)/g, `$1${newIndex}`)
            }

            bookingEl.dataset.bookingIndex = String(newIndex)
            bookingEl.id = rewriteValue(bookingEl.id)

            bookingEl.querySelectorAll('*').forEach((el) => {
                if (el.dataset && el.dataset.bookingIndex !== undefined) {
                    el.dataset.bookingIndex = String(newIndex)
                }

                if (el.id) {
                    el.id = rewriteValue(el.id)
                }

                if (el.name) {
                    el.name = rewriteValue(el.name)
                }

                const currentFor = el.getAttribute?.('for')
                if (currentFor) {
                    el.setAttribute('for', rewriteValue(currentFor))
                }
            })
        })
    }

  selectListing(listingLine) {
    if (this.hasLoadMoreBtnTarget) {
        this.loadMoreBtnTarget.classList.add('is-hidden');
    }
    const listingRemoveBtn = document.createElement("i");
    listingRemoveBtn.classList.add("icon-trash-can");
    listingRemoveBtn.classList.add("listing-remove");
    listingRemoveBtn.addEventListener("click", (event) => {
      event.stopPropagation();
      listingRemoveBtn.remove();
      listingLine.classList.remove("selected");
      this.updateOfferListingId();
    });

    const cancellationPolicy =
      listingLine.getAttribute("data-listing-cancellation-policy") || this.defaultCancellationPolicy;
    $("#offer_cancellation_policy").val(cancellationPolicy).trigger("change");

    let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();
    let editTrue = document.getElementById("offer_edit_form")?.value === "true";

    if (!bulk && !editTrue) {
      document.querySelectorAll("#listings_list .listing-line.selected").forEach((line) => {
          line.classList.remove("selected");
          line.querySelector("i.listing-remove").remove();
      });
      listingLine.classList.add("selected");
      listingLine.append(listingRemoveBtn);
      this.updateOfferListingId();

      clearTimeout(this.nextStepTimer);
      this.nextStepTimer = setTimeout(() => {
          document.querySelector("#rent_link").click();
      }, 500);
    }

    let selectedListings = document.getElementById("selected_listings");
    let selectedListingsList = document.getElementById("selected_listings_list");

    if (!bulk) {
        listingLine.classList.add("selected");
        listingLine.append(listingRemoveBtn);
    } else if (bulk && selectedListings) {
        const form = document.getElementById("offer_bulk_form");

        const bookingIndex = document.querySelectorAll("#selected_listings .bulk-selected").length;
        let listingId = listingLine.dataset['listingId'];

        let copiedListingLine = listingLine.cloneNode(true);
        copiedListingLine.classList.add("bulk-selected");
        copiedListingLine.classList.remove("d-none");

        let bookingRemoveBtn = listingRemoveBtn.cloneNode(true);

        const newDateContainer = this.createFreshDateContainer(bookingIndex, listingId);
        let newPriceContainer = this.createFreshPriceContainer(bookingIndex, listingId);
        newDateContainer.firstElementChild.dataset.listingId = listingId;

        newDateContainer.firstElementChild.dataset.dateRangeAvailabilityUrl = this.availabilityUrlTemplate.replace(
            "listingId",
            listingId
        );
        newDateContainer.firstElementChild.dataset.dateRangeCheckAvailabilityUrl = this.checkAvailabilityUrlTemplate.replace(
            "listingId",
            listingId
        );

         bookingRemoveBtn.addEventListener("click", (event) => {
             event.stopPropagation();
             copiedListingLine.remove();
             newDateContainer.remove();
             newPriceContainer.remove();
             this.reindexBulkBookings();
             this.recalculateBulkTotal();
             this.onPriceOptionsChanged();
             let selectedListingsPresent = document.getElementById("selected_listings").hasChildNodes();
             if (selectedListingsPresent) {
                 this.showAddBookingBtn();
             } else {
                 this.showElements();
                 this.moveSelectedToTop();
                 this.hideAddBookingBtn();
             }
             this.updateOfferListingId();
             if (document.querySelectorAll("#selected_listings .bulk-selected").length === 0) {
                 if (this.hasFromTarget) this.fromTarget.value = "";
                 if (this.hasToTarget) this.toTarget.value = "";
                 document.getElementById("selected_listings")?.classList.add("hidden");
             }
         });

        copiedListingLine.append(bookingRemoveBtn);
        copiedListingLine.classList.add("bg-white");

        newDateContainer.appendChild(newPriceContainer);

        let inputs = newDateContainer.querySelectorAll("input.date-range:not(#offer_to):not(#offer_from)");
        let inputFrom = document.getElementById("offer_from");
        let inputTo = document.getElementById("offer_to");
        inputs.forEach(input => {
            input.setAttribute('data-validate', 'true');
        });
        inputFrom?.setAttribute('data-validate', 'false');
        inputTo?.setAttribute('data-validate', 'false');

        selectedListingsList.classList.remove("hidden");
        selectedListings.classList.remove("hidden");
        selectedListings.appendChild(newDateContainer);
        newDateContainer.insertBefore(copiedListingLine, newDateContainer.firstChild);

        form.querySelector('.total-price__section a')?.classList.add("d-none");
    }

        this.updateOfferListingId();

        if (this.hasOfferTarget && this.hasListingListTarget) {
            [this.offerTarget, this.listingListTarget].forEach(el => {
                el.classList.add("is-hidden");
                el.parentElement.classList.add("is-hidden");
            })
        }

        const selected = document.querySelectorAll('#selected_listings .selected_listings_date');
        const newIndex = 0;

        selected.forEach((bookingEl, newIndex) => {
            bookingEl.dataset.bookingIndex = String(newIndex)

            bookingEl.querySelectorAll('div').forEach(div => {
                const id = div.id;
                div.id = id.replace(/_\d+_/, `_${newIndex}_`);
            });
        })
    }

    createFreshDateContainer(index, listingId) {
        const container = document.createElement("div");
        container.id = `selected_listings_date_${index}`;
        container.className = "selected_listings_date bg-gray-100 p-5 mb-5";
        container.dataset.bookingIndex = index;
        container.dataset.listingId = listingId;

        container.dataset.dateRangeAvailabilityUrl = this.availabilityUrlTemplate.replace(
            "listingId",
            listingId
        );
        container.dataset.dateRangeCheckAvailabilityUrl = this.checkAvailabilityUrlTemplate.replace(
            "listingId",
            listingId
        );

        document.querySelector("#offer_listing_id").value = listingId;

        const originalDateTemplate = document.getElementById('selected_listings_date');
        if (!originalDateTemplate) return container;

        const newDateController = originalDateTemplate.querySelector('[data-controller="date-range"]')?.cloneNode(true);
        newDateController.id = `date_range_${index}`;

        newDateController.querySelectorAll('input[type="text"], input[type="hidden"], .flatpickr-input').forEach(input => {
            input.value = '';
        });
        newDateController.querySelectorAll('.flatpickr-calendar').forEach(calendar => calendar.remove());

        const fromInput = newDateController.querySelector('input[name="offer[from]"]') || newDateController.querySelector('input.date-range');
        const toInput = newDateController.querySelector('input[name="offer[to]"]') || Array.from(newDateController.querySelectorAll('input.date-range'))[1];
        const rentInput = newDateController.querySelector('input[name="offer[rent_total]"]');

        if (fromInput) {
            fromInput.name = `booking_${index}[from]`;
            fromInput.id = `booking_${index}_from`;
            fromInput.dataset.bookingIndex = index;
            fromInput.dataset.dateRangeAvailabilityUrl = this.availabilityUrlTemplate.replace(
                "listingId",
                listingId
            );
            fromInput.dataset.dateRangeCheckAvailabilityUrl = this.checkAvailabilityUrlTemplate.replace(
                "listingId",
                listingId
            );
            fromInput.disabled = false;
        }
        if (toInput) {
            toInput.name = `booking_${index}[to]`;
            toInput.id = `booking_${index}_to`;
            toInput.dataset.bookingIndex = index;
            toInput.dataset.dateRangeAvailabilityUrl = this.availabilityUrlTemplate.replace(
                "listingId",
                listingId
            );
            toInput.dataset.dateRangeCheckAvailabilityUrl = this.checkAvailabilityUrlTemplate.replace(
                "listingId",
                listingId
            );
            toInput.disabled = false;
        }
        if (rentInput) {
            rentInput.name = `booking_${index}[rent_total]`;
            rentInput.id = `booking_${index}_rent_total`;
        }

        container.appendChild(newDateController);

        setTimeout(() => {
            this.initDateRangeController(container, listingId, index);

            const labels = newDateController.querySelectorAll('label');
            if (labels[0]) labels[0].htmlFor = `booking_${index}_from`;
            if (labels[1]) labels[1].htmlFor = `booking_${index}_to`;

            const syncDates = () => {
                const fpInput = newDateController.querySelector('.flatpickr-input');
                const fp = fpInput?._flatpickr;
                if (fp?.selectedDates?.length >= 2 && fromInput && toInput) {
                    fromInput.value = fp.formatDate(fp.selectedDates[0], 'm/d/Y');
                    toInput.value = fp.formatDate(fp.selectedDates[1], 'm/d/Y');
                    fromInput.dispatchEvent(new Event('change', { bubbles: true }));
                    toInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            };

            const syncCheck = setInterval(syncDates, 250);
            setTimeout(() => clearInterval(syncCheck), 3000);
        }, 250);

        return container;
    }

    initDateRangeController(dateContainer, listingId, index) {
        const dateRangeEl = dateContainer.querySelector('[data-controller="date-range"]');
        if (!dateRangeEl) return;

        dateRangeEl.querySelectorAll('.flatpickr-input').forEach(input => {
            if (input._flatpickr) {
                input._flatpickr.destroy();
                delete input._flatpickr;
            }
            input.closest('.flatpickr-calendar')?.remove();
        });

        dateRangeEl.dataset.bookingIndex = index;
        const holder = dateRangeEl.querySelector('[data-date-range-target="holder"]');
        if (holder) holder.dataset.bookingIndex = index;

        dateRangeEl.removeAttribute('data-controller');
        dateRangeEl.setAttribute('data-controller', 'date-range');
        dateRangeEl.dispatchEvent(new CustomEvent('connect', { bubbles: true }));
        dateRangeEl.dispatchEvent(new CustomEvent('stimulus:initialize', { bubbles: true }));

        const firstInput = dateRangeEl.querySelector('.date-range');
        if (firstInput) {
            firstInput.focus();
            firstInput.click();
        }
    }

    createFreshPriceContainer(index, listingId) {
        const container = document.createElement("div");
        container.id = `selected_listings_price_${index}`;
        container.className = "pt-2";
        container.dataset.bookingIndex = index;
        container.dataset.listingId = listingId;

        const priceDiv = document.createElement("div");
        priceDiv.className = "booking-invitation__total-price";
        container.appendChild(priceDiv);

        return container;
    }

    parseAmount(text) {
        const cleaned = (text || "").replace(/[^\d.,]/g, "");

        const lastDot = cleaned.lastIndexOf(".");
        const lastComma = cleaned.lastIndexOf(",");

        let normalized;
        if (lastComma > lastDot) {
            normalized = cleaned.replace(/\./g, "").replace(",", ".");
        } else {
            normalized = cleaned.replace(/,/g, "");
        }

        const n = parseFloat(normalized);
        return Number.isFinite(n) ? n : 0;
    }


    formatMoney(amount) {
        return amount.toLocaleString(this.locale || undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    recalculateBulkTotal() {
        let total = 0;
        let original_total = 0;
        let vat = 0;
        const bulkBookings = document.querySelectorAll("#selected_listings .bulk-selected");

        bulkBookings.forEach((booking) => {
            const priceContainer = booking.parentElement;
            const priceElement = priceContainer?.querySelector(".total-price-amount");
            const originalPriceElement = priceContainer?.querySelector("#original_rent_total");
            const vatElement = priceContainer?.querySelector(".rent-vat-amount");

            if (!priceElement) return;

            total += this.parseAmount(priceElement.textContent);
            if (originalPriceElement) {
                original_total += this.parseAmount(originalPriceElement.value);
            }
            if (vatElement) {
                vat += this.parseAmount(vatElement.textContent);
            }
        });

        const originalPriceElement = document.getElementById("original-price-total");
        const discountAmountElement = document.querySelector(".discount-amount")?.parentElement?.parentElement?.querySelector(".label");
        const totalDiscountAmountElement = document.querySelector(".total-rent-amount.discount_amount");
        const discountPercentageElement = document.querySelector(".discount-amount");
        const totalDiscountPercentageElement = document.querySelector(".label.discount_percentage");
        const discountBlockWrapper = totalDiscountAmountElement?.parentElement?.parentElement
        if (discountPercentageElement) {
            const discountPercentageTextContent = discountPercentageElement.textContent
            const discountAmountTextContent = discountAmountElement.textContent
            if (discountAmountElement && discountAmountTextContent) {
                totalDiscountAmountElement.innerText = "-" + (original_total * (this.parseAmount(discountAmountTextContent) / 100)).toFixed(2);
            }
            if (discountPercentageElement && discountPercentageTextContent) {
                totalDiscountPercentageElement.innerText = discountAmountTextContent;
            }
        }

        if (originalPriceElement) {
            originalPriceElement.innerText = this.formatMoney(original_total);
        }
        const mainPriceElement = document.getElementById("total-price-amount");

        if (mainPriceElement) {
            mainPriceElement.textContent = this.formatMoney(total);
        }

        if (discountBlockWrapper && discountPercentageElement == null) {
            discountBlockWrapper.classList.add("is-hidden");
        } else if (discountBlockWrapper) {
            discountBlockWrapper.classList.remove("is-hidden");
        }

        const vatPriceElement = document.getElementById("rent-vat-amount");

        if (vatPriceElement) {
            vatPriceElement.textContent = this.formatMoney(vat);
        }
  }

  updateOfferListingId() {
    const listingIdContainer = document.getElementById("offer_listing_id");
    let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();
    let selectedListingLine;
    if (bulk) {
        selectedListingLine = document.querySelector("#selected_listings .listing-line.bulk-selected");
    } else {
        selectedListingLine = document.querySelector("#listings_list .listing-line.selected");
    }

    this.dispatch("listingChanged");

    if (selectedListingLine) {
        let listingId = selectedListingLine.getAttribute("data-listing-id");
        listingIdContainer.value = listingId;
        if (!bulk) {
            this.dateRangeTarget.dataset.listingId = listingId;
            this.dateRangeTarget.dataset.dateRangeAvailabilityUrl = this.availabilityUrlTemplate.replace(
                "listingId",
                listingId
            );
            this.dateRangeTarget.dataset.dateRangeCheckAvailabilityUrl = this.checkAvailabilityUrlTemplate.replace(
                "listingId",
                listingId
            );
        }

        if (this.hasDateHintTarget) {
            $(this.dateHintTarget).hide();
        }
    } else {
        listingIdContainer.value = null;
        if (this.hasDateHintTarget) {
            $(this.dateHintTarget).show();
        }
    }
    if (!bulk) {
        if (this.hasFromTarget) this.fromTarget.value = "";
        if (this.hasToTarget) this.toTarget.value = "";

    }

    if (!bulk && selectedListingLine) {
        clearTimeout(this.nextStepTimer);
        this.nextStepTimer = setTimeout(() => {
            document.querySelector("#rent_link")?.click();
        }, 500);
    }

    let selectedListings = document.querySelectorAll("#selected_listings .bulk-selected");
    let editTrue = document.getElementById("offer_edit_form")?.value === "true";
    const hasAnyPrice = Array.from(selectedListings).some(el => el.parentElement.querySelector(".total-price-amount"));

    if (!hasAnyPrice && editTrue) {
        this.loadPriceOptions();
        this.onPriceOptionsChanged();
    }
  }

  onPriceChanged(event) {
    let listingId = document.querySelector("#offer_listing_id")?.value || "";
    let bookingIndex = document.querySelector("#booking_index")?.value || "";

    let startDateStr = bookingIndex ? document.getElementById(`booking_${bookingIndex}_from`)?.value : this.fromTarget.value;
    let endDateStr = bookingIndex ? document.getElementById(`booking_${bookingIndex}_to`)?.value : this.toTarget.value;

    if (startDateStr === "" || endDateStr === "") {
        return
    }
    let halfDayInSeconds = 0.5 * 24 * 3600;
    let startUTCTimestamp = moment(startDateStr, this.dateFormat).toDate().getTime() / 1000 + halfDayInSeconds;
    let endUTCTimestamp = moment(endDateStr, this.dateFormat).toDate().getTime() / 1000 + halfDayInSeconds;
    const rentTotalInput = document.querySelector("#offer_rent_total");
    if (rentTotalInput) rentTotalInput.value = event.detail.value;
    let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();

    if (!bulk) {
        this.refreshPrice(startUTCTimestamp, endUTCTimestamp, listingId, event.detail.value, bookingIndex);
    }
}

    onPriceOptionsChanged() {
        let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();

        if (!bulk) {
            const startDateStr = this.fromTarget.value;
            const endDateStr = this.toTarget.value;
            const listingId = document.querySelector("#offer_listing_id").value;

            if (startDateStr === "" || endDateStr === "" || listingId === "") {
                this.priceTarget.innerHTML = "";
                return;
            }

            let halfDayInSeconds = 0.5 * 24 * 3600;
            let startUTCTimestamp = moment(startDateStr, this.dateFormat).toDate().getTime() / 1000 + halfDayInSeconds;
            let endUTCTimestamp = moment(endDateStr, this.dateFormat).toDate().getTime() / 1000 + halfDayInSeconds;

            this.refreshPrice(startUTCTimestamp, endUTCTimestamp, listingId, null, null);
        } else {
            const bookingIndexCount = document.querySelectorAll("#selected_listings .bulk-selected").length;

            [...Array(bookingIndexCount).keys()].forEach((i) => {
                let listingId = document.getElementById(`selected_listings_date_${i}`)?.getAttribute("data-listing-id");
                let bookingIndex = i;
                if (listingId === "" || listingId === null) {
                    return
                }

                let startDateStr = document.getElementById(`booking_${bookingIndex}_from`)?.value || "";
                let endDateStr = document.getElementById(`booking_${bookingIndex}_to`)?.value || "";

                if (startDateStr === "" || endDateStr === "") {
                    return
                }

                if (this.hasPriceTarget) {
                    if (startDateStr === "" || endDateStr === "" || listingId === "") {
                        this.priceTarget.innerHTML = "";
                        return;
                    }
                }

                let halfDayInSeconds = 0.5 * 24 * 3600;
                let startUTCTimestamp = moment(startDateStr, this.dateFormat).toDate().getTime() / 1000 + halfDayInSeconds;
                let endUTCTimestamp = moment(endDateStr, this.dateFormat).toDate().getTime() / 1000 + halfDayInSeconds;

                this.refreshPrice(startUTCTimestamp, endUTCTimestamp, listingId, null, bookingIndex);
            });
        }
    }

  loadPriceOptions() {
    const bookingIndexCount = document.querySelectorAll("#selected_listings .bulk-selected").length;

    [...Array(bookingIndexCount).keys()].forEach((i) => {
        let listingId = document.getElementById(`selected_listings_date_${i}`)?.getAttribute("data-listing-id");
        let bookingIndex = i;
        if (listingId === "" || listingId === null) {
            return
        }

        let startDateStr = document.getElementById(`booking_${bookingIndex}_from`)?.value || "";
        let endDateStr = document.getElementById(`booking_${bookingIndex}_to`)?.value || "";

        if (startDateStr === "" || endDateStr === "") {
            return
        }

        if (this.hasPriceTarget) {
            if (startDateStr === "" || endDateStr === "" || listingId === "") {
                this.priceTarget.innerHTML = "";
                return;
            }
        }

        let halfDayInSeconds = 0.5 * 24 * 3600;
        let startUTCTimestamp = moment(startDateStr, this.dateFormat).toDate().getTime() / 1000 + halfDayInSeconds;
        let endUTCTimestamp = moment(endDateStr, this.dateFormat).toDate().getTime() / 1000 + halfDayInSeconds;
        let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();

        if (!bulk) {
            this.refreshPrice(startUTCTimestamp, endUTCTimestamp, listingId, null, bookingIndex);
        }
    });
  }

  refreshPrice(start, end, listingId, rent, bookingIndex) {
    let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();

    const bulkSelectedListings = document.querySelectorAll('#selected_listings .bulk-selected');
    let editTrue = document.getElementById("offer_edit_form")?.value === "true";

    let bookingDataArray = Array.from(bulkSelectedListings).map((bookingEl) => {
        let dateContainer = bookingEl.parentElement;
        let bookingIndex = editTrue ? bookingEl?.dataset?.bookingIndex : dateContainer?.dataset?.bookingIndex;
        let listingId = bookingEl.getAttribute("data-listing-id");
        let fromInput = document.getElementById(`booking_${bookingIndex}_from`);
        let toInput = document.getElementById(`booking_${bookingIndex}_to`);

        return {
          listing_id: listingId,
          from: fromInput?.value,
          to: toInput?.value
        };
    });

    if (this.hasPriceTarget || bulk) {
        const rentStr = rent == null ? "" : rent;
        const displayDiscountFlag = bulk ? false : this.modalType == "offer";
        fetch(
            `${this.priceUrl}?listing_id=${listingId}&start=${start}&end=${end}&rent_total=${rentStr}&display_discount_flag=${displayDiscountFlag}&read_only=${bulk ? "true" : false}&bulk_bookings=${JSON.stringify(bookingDataArray)}`
        )
            .then((response) => response.text())
            .then((html) => {
                if (editTrue) {
                    let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();
                    const sendBtn = bulk ? document.querySelector("#offer_bulk_form .send-btn") : document.querySelector("#offer_form .send-btn");
                    if (sendBtn) {
                        sendBtn.disabled = false;
                    }
                }
                if ((this.hasFromTarget && this.fromTarget.value === "") || (this.hasToTarget && this.toTarget.value === "")) {
                    return;
                }
                if (bulk) {
                    document.querySelectorAll("#selected_listings .bulk-selected").forEach((booking) => {
                        if (booking.dataset.listingId !== String(listingId)) return;
                        if (bookingIndex == null) return;

                        const priceContainer = document.getElementById(`selected_listings_price_${bookingIndex}`);
                        const priceDiv = priceContainer?.querySelector(".booking-invitation__total-price");
                        if (priceDiv) priceDiv.innerHTML = html;
                    });

                    this.recalculateBulkTotal();
                } else if (this.hasPriceTarget) {
                    this.priceTarget.innerHTML = html;
                    this.priceTarget.style.display = "block";
                }
            });
        let lastBookingIndex = document.querySelector("#booking_index")?.value || "";
        const dateContainerFilled = document.getElementById(`booking_${lastBookingIndex || bookingIndex}_to`)?.value != ''

        if (dateContainerFilled) {
            this.showAddBookingBtn();

            let datesErrorPresent = !!Array.from(document.querySelectorAll('[id^="offer_dates_"][id$="_error"]'))
                .find(el => el.textContent.trim())

            if (datesErrorPresent) {
                setTimeout(() => {
                    Array.from(document.querySelectorAll('[id^="offer_dates_"][id$="_error"]'))
                        .find(el => el.textContent = '')
                }, 3000);
            }
        }
    }
  }

  updateSectionIndicator(section) {
    const validatedInputs = Array.from(section.querySelectorAll('[data-validate="true"]'));
    const filled = validatedInputs.every((input) => {
      return !!input.value;
    });
    const sectionHeader = document.querySelector(`.section__header[data-target="#${section.getAttribute("id")}"]`);
    if (sectionHeader) {
      if (filled) {
          const isStep2 = sectionHeader.classList.contains('step-2');
          let shouldClearErrors = true;

          if (isStep2) {
              if (!!Array.from(document.querySelectorAll('[id^="offer_dates_"][id$="_error"]'))
                  .find(el => el.textContent.trim())) {
                  shouldClearErrors = false;
              }
              else {
                  shouldClearErrors = true;
              }
          }

          if (shouldClearErrors) {
              section.querySelectorAll(".modal__offer .input__error").forEach((errorHolder) => {
                  errorHolder.innerHTML = "";
                  errorHolder.classList.add("is-hidden");
              });
              sectionHeader.classList.remove("invalid");
              sectionHeader.classList.add("filled");
          }
      } else {
        sectionHeader.classList.remove("filled")
      }
    }
  }

  toggleTenantPaidField(type) {
    const tenantPaidField = document.querySelector(".tenant_paid_field");

    if (!tenantPaidField) {
      return;
    }

    if (type === "booking") {
      tenantPaidField.classList.remove("is-hidden");
    } else {
      tenantPaidField.classList.add("is-hidden");
    }
  }

  toggleDisableEmailToTenant(type) {
    const disableEmailToTenantField = document.querySelector(".disable_email_to_tenant_field");

    if (!disableEmailToTenantField) {
      return;
    }

    if (type === "booking") {
      disableEmailToTenantField.classList.remove("is-hidden");
    } else {
      disableEmailToTenantField.classList.add("is-hidden");
    }
  }

  toggleExpiresInField(type) {
    const expiresInField = document.querySelector(".expires_in_field");

    if (!expiresInField) {
      return;
    }

    if (type === "booking") {
      expiresInField.classList.add("is-hidden");
    } else {
      expiresInField.classList.remove("is-hidden");
    }
  }

  updateHeader(type) {
    const headerTitle = document.querySelector("#offer_modal .modal-title");
    if (headerTitle) {
      headerTitle.innerText = t(`offers.title.${type}`, this.locale);
    }
  }

  updateDescription(type) {
    const description = document.querySelector("#offer_modal .modal-description");
      if (description) {
          description.innerText = t(`offers.descriptions.${type}`, this.locale);
      }
  }

  updateSubmitButton(type) {
    let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();
    const sendBtn = bulk ? document.querySelector("#offer_bulk_form .send-btn") : document.querySelector("#offer_form .send-btn");
    if (sendBtn) {
      sendBtn.innerText = t(`offers.controls.${type}`, this.locale);
    }
  }

  sendOffer(sendBtn) {
    sendBtn.disabled = true;

    let bulk = document.getElementById("offer_bulk_form")?.checkVisibility();
    const form = bulk ? document.getElementById("offer_bulk_form") : document.getElementById("offer_form");
    const method = form.getAttribute("data-method");
    const action = form.getAttribute("data-action");
    const userId = document.querySelector("#offer_user_id")?.value;
    const cartNo = document.querySelector("#offer_cart_no")?.value;
    const editForm = document.querySelector("#offer_edit_form")?.value;
    const bulkSelectedListings = document.querySelectorAll('#selected_listings .bulk-selected');
    const listingIds = Array.from(bulkSelectedListings).map(el => el.dataset.listingId);
    let disableDiscounts = false;
    const disableDiscountsInput = document.querySelector("#offer_disable_discounts");
    if (disableDiscountsInput) {
        disableDiscounts = disableDiscountsInput.checked;
    }
    const bulkBookingsName = document.querySelector("#offer_bulk_bookings_name")?.value || "";
    const message = document.querySelector("#offer_offer_message")?.value || "";
    const overallLook = document.querySelector("#offer_overall_look")?.value || "";
    const rentTotal = document.querySelector("#offer_rent_total")?.value || "";
    const cancellationPolicy = document.querySelector("#offer_cancellation_policy")?.value || "";
    const otherTerms = document.querySelector("#offer_other_terms")?.value || "";
    const offerExpiresInInput = document.querySelector("#offer_offer_expires_in");
    const tenantPaidInput = document.querySelector('input[name="offer[tenant_paid]"]:checked');
    const collectedByInput = document.querySelector('input[name="offer[collected_by]"]:checked');
    const disableEmailToTenantInput = document.querySelector("#offer_disable_email_to_tenant");
    const industry = Array.from(document.querySelectorAll("#offer_industry option:checked")).map(
      (option) => option.value
    );
    const attachments = Array.from(document.querySelectorAll('input[name="booking[landlord_attachment_ids][]"]')).map(
      (input) => input.value
    );

    let channelId = null;
    const channelInput = document.querySelector("#offer_channel");
    if (channelInput) {
      channelId = channelInput.value;
    }

    let unitId = null;
    const unitInput = document.querySelector("#offer_unit");
    if (unitInput) {
      unitId = unitInput.value;
    }

    let type = this.modalType;
    let offerExpiresIn = null;
    let tenantPaid = null;
    let collectedBy = null;
    let disableEmailToTenant = false;

    if (this.differentTypesAllowed) {
      type = document.querySelector("#offer_type")?.value;
    }

    if (tenantPaidInput && type === "booking") {
      tenantPaid = tenantPaidInput.value === "true";
    }

    if (collectedByInput && type === "booking" && !tenantPaid) {
      collectedBy = collectedByInput.value;
    }

    if (offerExpiresInInput && (type === "offer" || bulk)) {
      offerExpiresIn = offerExpiresInInput.value;
    }

    if (disableEmailToTenantInput && type === "booking") {
      disableEmailToTenant = disableEmailToTenantInput.checked;
    }

    if (bulk) {
        const bulkBookings = document.querySelectorAll("#selected_listings .bulk-selected");

        let bookingDataArray = Array.from(bulkBookings).map((bookingEl) => {
            let dateContainer = bookingEl.parentElement;
            let bookingIndex = dateContainer?.dataset?.bookingIndex;
            let singleRentTotal = dateContainer?.querySelector(".total-rent-amount")?.innerText || 0;
            let singleOriginalPrice = dateContainer?.querySelector(".original-total-rent-price")?.innerText || 0;
            let listingId = bookingEl.getAttribute("data-listing-id");
            let fromInput = document.getElementById(`booking_${bookingIndex}_from`);
            let toInput = document.getElementById(`booking_${bookingIndex}_to`);

            return {
                user_id: userId,
                listing_id: listingId,
                from: fromInput?.value,
                to: toInput?.value,
                rent_total: singleRentTotal,
                original_price: singleOriginalPrice,
                cancellation_policy: cancellationPolicy,
                offer_expires_in: offerExpiresIn,
                other_terms: otherTerms,
                offer_message: message,
                industry: industry,
                overall_look: overallLook,
                disable_discounts: disableDiscounts,
                ...(unitId !== null && { landlord_action_unit_id: unitId }),
                ...(attachments.length > 0 && { landlord_attachment_ids: attachments }),
            };
        });

        $.ajax({
            url: action,
            type: method,
            data: {
                offer: {
                    cart_no: cartNo,
                    bulk_bookings_name: bulkBookingsName,
                    edit_form: editForm,
                    user_id: userId,
                    type: type,
                    listing_ids: listingIds,
                    bulk_bookings: bookingDataArray,
                    disable_email_to_tenant: disableEmailToTenant,
                    channel_id: channelId
                },
            },
        })
        .done((data) => {
            sendBtn.disabled = false;
            if (data.errors) {
                this.showErrorNotifications(data.errors);
            } else {
                window.location.reload();
            }
        })
        .fail(() => {
            sendBtn.disabled = false;
            $(this.modalTarget).modal("hide");
        });
    } else {
    let listingId = document.querySelector("#offer_listing_id")?.value;
    const from = document.querySelector("#offer_from")?.value;
    const to = document.querySelector("#offer_to")?.value;

    $.ajax({
      url: action,
      type: method,
      data: {
        offer: {
          user_id: userId,
          type: type,
          listing_id: listingId,
          from: from,
          to: to,
          rent_total: rentTotal,
          tenant_paid: tenantPaid,
          collected_by: collectedBy,
          disable_email_to_tenant: disableEmailToTenant,
          cancellation_policy: cancellationPolicy,
          offer_expires_in: offerExpiresIn,
          other_terms: otherTerms,
          offer_message: message,
          industry: industry,
          overall_look: overallLook,
          disable_discounts: disableDiscounts,
          channel_id: channelId,
          ...(unitId !== null && { landlord_action_unit_id: unitId }),
          ...(attachments.length > 0 && { landlord_attachment_ids: attachments }),
        },
      },
    })
      .done((data) => {
          sendBtn.disabled = false;
        if (data.errors) {
          this.showErrorNotifications(data.errors);
        } else {
          window.location.reload();
        }
      })
      .fail(() => {
        sendBtn.disabled = false;
        $(this.modalTarget).modal("hide");
      });
  }
  }

  showErrorNotifications(errors) {
    document.querySelectorAll(".modal__offer .input__error").forEach((errorHolder) => {
      errorHolder.innerHTML = "";
      errorHolder.classList.add("is-hidden");
    });

    document.querySelectorAll(".modal__offer .accordion-section").forEach((section) => {
      section.classList.remove("invalid");
    });

    Object.entries(errors).forEach((error) => {
      let fieldName = error[0];
      const errorMessage = error[1];

      if (fieldName === "dates") {
        document.querySelector("#offer_from").value = null;
        document.querySelector("#offer_to").value = null;
      }

      const errorHolder = document.getElementById(`offer_${fieldName}_error`);
      if (errorHolder) {
          const sectionName = errorHolder.getAttribute("data-section");
          if (!sectionName) return;
          requestAnimationFrame(() => {
              const section = document.querySelector(`.accordion-section.${sectionName}`);

              if (section) {
                  section.classList.add("invalid");
              }
              errorHolder.classList.remove("is-hidden");
              errorHolder.innerHTML = Array.isArray(errorMessage) ? errorMessage[0] : errorMessage;
          });
      }
    });
  }

  get loadMoreText() {
    return this.data.get("loadMoreText") || "Load more";
  }

  get locale() {
    return this.data.get("locale") || "en";
  }

  get priceUrl() {
    return this.data.get("priceUrl");
  }

  get modalType() {
    return this.data.get("modalType");
  }

  get dateFormat() {
    return this.data.get("dateFormat");
  }

  get differentTypesAllowed() {
    return this.data.get("differentTypesAllowed") === "true";
  }

  get checkAvailabilityUrlTemplate() {
    return this.data.get("checkAvailabilityUrlTemplate");
  }

  get availabilityUrlTemplate() {
    return this.data.get("availabilityUrlTemplate");
  }

  get defaultCancellationPolicy() {
    return this.data.get("defaultCancellationPolicy");
  }
}
